export const iconFontAwesomeUsersPeopleHospitalUser = (
	<i className="fa-solid fa-hospital-user"></i>
);
